export function getEnv(key: string): string {
  const runtimeValue = (window as any).__ENV__?.[key];
  if (runtimeValue) return runtimeValue;
  return process.env[key] || '';
}
